<template>
  <div class="data-preview">
    <h4>What we'll include:</h4>
    <ul>
      <li>📸 Screenshot of current page</li>
      <li>🔍 Console logs ({{ consoleLogCount }} entries)</li>
      <li>🌐 Recent API calls ({{ networkCallCount }} calls)</li>
      <li>💻 Browser and device information</li>
      <li>📄 Current page information</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DataPreview',
  
  props: {
    consoleLogCount: {
      type: Number,
      default: 0
    },
    networkCallCount: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.data-preview {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.data-preview h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.data-preview ul {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #6b7280;
}

.data-preview li {
  margin-bottom: 4px;
}
</style>